import { useNavigate } from "react-router-dom";
import { mediaSrc } from "../../lib/api";
import { useBrandImage, useIsTemporary } from "../../lib/brand";
import { Swoosh } from "./Swoosh";

const BASE = process.env.PUBLIC_URL || "";
// Internal CMS links ("/path", not "//host") get the deploy base path; external links are left untouched.
const withBase = (html) => (html || "").replace(/href="\/(?!\/)([^"]*)"/g, (_, p) => `href="${BASE}/${p}" data-internal="/${p}"`);

export const PageHero = ({ eyebrow, title, subtitle, image, children, testid = "page-hero" }) => {
  const banner = useBrandImage("banner");
  const isTemp = useIsTemporary();
  const own = image && !isTemp(image);
  const bg = own ? { src: mediaSrc(image) } : banner;
  return (
    <section className="on-dark relative overflow-hidden bg-navy text-white" data-testid={testid}>
      {bg && <img src={bg.src} srcSet={bg.srcSet} sizes="60vw" alt="" aria-hidden="true" data-testid={`${testid}-art`}
        className={`absolute inset-y-0 right-0 h-full object-cover ${own ? "w-full" : "w-full sm:w-3/5 lg:w-1/2"}`} />}
      <div className="absolute inset-0 bg-navy/80 sm:bg-transparent sm:bg-gradient-to-r sm:from-navy sm:from-40% sm:via-navy/70 sm:to-navy/5" aria-hidden="true" />
      <div className="container-site relative pb-20 pt-14 lg:pb-24 lg:pt-20">
        {eyebrow && <p className="eyebrow-gold mb-3">{eyebrow}</p>}
        <h1 className="font-display max-w-3xl text-4xl sm:text-5xl lg:text-6xl">{title}</h1>
        {subtitle && <p className="mt-4 max-w-2xl text-lg text-white/90">{subtitle}</p>}
        {children}
      </div>
      <Swoosh />
    </section>
  );
};

export const RichText = ({ html, className = "", testid }) => {
  const navigate = useNavigate();
  const onClick = (e) => {
    const a = e.target.closest("a[data-internal]");
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || a.target === "_blank") return;
    e.preventDefault();
    navigate(a.dataset.internal);
  };
  return (
    <div className={`rich-text text-lg leading-relaxed text-[#4A5568] ${className}`} data-testid={testid} onClick={onClick} dangerouslySetInnerHTML={{ __html: withBase(html) }} />
  );
};

export const SectionHeading = ({ eyebrow, title, className = "" }) => (
  <div className={className}>
    {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
    <h2 className="font-display text-3xl text-navy sm:text-4xl">{title}</h2>
  </div>
);

const HibiscusEdge = () => {
  const img = useBrandImage("hibiscus");
  return img ? <img src={img.src} alt="" aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-0 hidden h-full w-auto object-cover opacity-95 lg:block" /> : null;
};

export const QuoteBand = ({ data }) => (
  <section className="on-dark relative overflow-hidden border-t-4 border-gold bg-navy py-16 text-white" data-testid="quote-section">
    <HibiscusEdge />
    <blockquote className="container-site relative max-w-4xl lg:pr-48">
      <p className="font-serif text-2xl italic leading-snug sm:text-3xl">
        <span className="text-gold" aria-hidden="true">“</span>{data.text}<span className="text-gold" aria-hidden="true">”</span>
      </p>
      <footer className="mt-5 text-white/85">— {data.attribution}</footer>
    </blockquote>
  </section>
);

export const Loading = () => <div className="container-site py-24 text-center text-[#4A5568]" aria-busy="true" data-testid="page-loading">Loading…</div>;
